import { DATE_VALUES, getRangeFromDateFilter } from 'utils/dateUtils'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from '../../PartnerOptions/constants'

import {
  DATE_FILTER_CHANGE,
  FETCH_DATA_ASYNC,
  LICENSE_DATA_REQUEST_ASYNC,
  RESET_SELECTED_ADDONS,
  TOGGLE_ADDON_TO_UNLOCK,
} from './constants'

export default function () {
  const initialState = {
    loader: false,
    data: {},
    error: null,
    dateFilter: DATE_VALUES.WEEK,
    license: {},
    selectedAddonsToUnlock: [],
    licenseLoader: false,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS:
      case FETCH_DATA_ASYNC.INITIATE:
        return {
          ...state,
          loader: true,
          error: null,
        }
      case FETCH_DATA_ASYNC.SUCCESS:
        return {
          ...state,
          data: action.payload.data,
          loader: false,
        }
      case FETCH_DATA_ASYNC.ERROR:
        return {
          ...state,
          error: action.error,
          loader: false,
        }
      case FETCH_DATA_ASYNC.CANCEL:
        return {
          ...state,
          loader: false,
          error: null,
        }
      case DATE_FILTER_CHANGE:
        return {
          ...state,
          loader: true,
          error: null,
          dateFilter: action.payload.value,
          feDateRange: getRangeFromDateFilter(action.payload.value),
        }
      case LICENSE_DATA_REQUEST_ASYNC.INITIATE:
        return {
          ...state,
          licenseLoader: true,
        }
      case LICENSE_DATA_REQUEST_ASYNC.SUCCESS: {
        return {
          ...state,
          error: null,
          license: { ...action.payload.data },
          licenseLoader: false,
        }
      }
      case LICENSE_DATA_REQUEST_ASYNC.ERROR:
        return {
          ...state,
          licenseLoader: false,
          error: action.payload,
        }
      case LICENSE_DATA_REQUEST_ASYNC.CANCEL:
        return {
          ...state,
          licenseLoader: false,
        }
      case TOGGLE_ADDON_TO_UNLOCK: {
        const selectedAddonsToUnlock = state.selectedAddonsToUnlock.includes(action.payload.addon)
          ? state.selectedAddonsToUnlock.filter((addon) => addon !== action.payload.addon)
          : [...state.selectedAddonsToUnlock, action.payload.addon]
        return { ...state, selectedAddonsToUnlock }
      }
      case RESET_SELECTED_ADDONS:
        return {
          ...state,
          selectedAddonsToUnlock: [],
        }
      default:
        return state
    }
  }
}
